import { Component, OnInit, ViewChild, ElementRef, HostListener } from '@angular/core';
import { first } from 'rxjs/operators';
import { Constants } from '../../../model/constants';
import { ActivatedRoute } from '@angular/router';
import { CorsoModulo } from '../../../model/corsomodulo';
import { Location } from '@angular/common';
import { ModuloService } from 'src/app/service/modulo.service';
import { User } from 'src/app/model/user';
import { UserService } from 'src/app/service/user.service';

@Component({
  selector: 'app-lezione',
  templateUrl: './lezione.component.html',
  styleUrls: ['./lezione.component.css']
})
export class LezioneComponent implements OnInit {

    user: User;
    corsoId: number;
    moduloId: number;
    corsoModulo: CorsoModulo;
    srcObj = null;
    slidesCounter: number;
    currentSlide = 1;
    fullScreen = false;
    rotation = 0;
    zoom = 1.0;
    @ViewChild('downloadModuloLink') private downloadModuloLink: ElementRef;

    SLIDE_BASE_URL = Constants.API_ENDPOINT + 'modulo/slide/download/';

    constructor(
        private route: ActivatedRoute,
        private location: Location,
        private userSrv: UserService,
        private moduloSrv: ModuloService
    ) { }

    ngOnInit() {
        this.getUser();
        this.route.paramMap.subscribe(params =>  {
            this.corsoId = +params.get('courseId');
            this.moduloId = +params.get('moduleId');
            this.loadModulo();
        });
    }

    @HostListener('document:keydown', ['$event'])
    keydown(e: KeyboardEvent) {
        if (e.key === 'ArrowLeft') {
            this.prevSlide();
        } else if (e.key === 'ArrowRight') {
            this.nextSlide();
        }
    }

    initViewer() {
        if (this.corsoModulo && this.corsoModulo.fileLezionePdf) {
            this.countSlides(this.corsoId, this.moduloId);
            this.srcObj = {
                url: this.SLIDE_BASE_URL + this.corsoId + '/' + this.moduloId + '/' + this.currentSlide,
                withCredentials: true
            };
        }
    }

    prevSlide() {
        if (this.currentSlide <= 1) {
            return;
        }
        this.currentSlide = this.currentSlide - 1;
        this.srcObj = {
            url: this.SLIDE_BASE_URL + this.corsoId + '/' + this.moduloId + '/' + this.currentSlide,
            withCredentials: true
        };
    }

    nextSlide() {
        if (this.currentSlide >= this.slidesCounter) {
            return;
        }
        this.currentSlide = this.currentSlide + 1;
        this.srcObj = {
            url: this.SLIDE_BASE_URL + this.corsoId + '/' + this.moduloId + '/' + this.currentSlide,
            withCredentials: true
        };
    }

    toggleFullScreen() {
        this.fullScreen = !this.fullScreen;
    }

    openFullScreen() {
        this.fullScreen = true;
    }

    closeFullScreen() {
        this.fullScreen = false;
    }

    rotateRight() {
        if (this.rotation === 270) {
            this.rotation = 0;
        } else {
            this.rotation = this.rotation + 90;
        }
    }

    rotateLeft() {
        if (this.rotation === 0) {
            this.rotation = 270;
        } else {
            this.rotation = this.rotation - 90;
        }
    }

    zoomIn() {
        if (this.zoom === 2.0) {
            return;
        }
        this.zoom = this.zoom + 0.1;
    }

    zoomOut() {
        if (this.zoom === 0.1) {
            return;
        }
        this.zoom = this.zoom - 0.1;
    }

    zoomReset() {
        this.zoom = 1.0;
    }

    backToModules() {
        this.location.back();
    }

    public async downloadModulo(): Promise<void> {
        const blob = await this.moduloSrv.downloadResource(this.corsoId, this.corsoModulo.id);
        if ('navigator' in window && 'msSaveOrOpenBlob' in navigator) {
            //@ts-ignore
            window.navigator.msSaveOrOpenBlob(blob, this.corsoModulo.fileLezionePdf);
        } else {
            const url = window.URL.createObjectURL(blob);
            const link = this.downloadModuloLink.nativeElement;
            link.href = url;
            link.download = this.corsoModulo.fileLezionePdf;
            link.click();
            window.URL.revokeObjectURL(url);
        }
    }

    private loadModulo() {
        this.moduloSrv.getModuloCertificazione(this.moduloId)
        .pipe(first())
        .subscribe(
            data => {
                this.corsoModulo = data;
                this.initViewer();
            },
            error => {
                return;
            }
        );
    }

    private countSlides(courseId: number, moduleId: number) {
        this.moduloSrv.countSlides(courseId, moduleId)
        .pipe(first())
            .subscribe(
                data => {
                    this.slidesCounter = data.result;
                },
                error => {
                    return;
                }
        );
    }

    private getUser() {
        this.userSrv.getUser()
        .pipe(first())
        .subscribe(
            data => {
                this.user = data;
            },
            error => {
                return;
            }
        );
    }

}

